module.exports = __webpack_public_path__ + "static/img/login_bg.96d76857.png";